import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
export const index = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/studio/{team}/scenarios/{scenario}/play-stats',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
index.url = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            team: args[0],
            scenario: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        team: typeof args.team === 'object'
        ? args.team.slug
        : args.team,
        scenario: typeof args.scenario === 'object'
        ? args.scenario.id
        : args.scenario,
    }

    return index.definition.url
            .replace('{team}', parsedArgs.team.toString())
            .replace('{scenario}', parsedArgs.scenario.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
index.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
index.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
const indexForm = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
indexForm.get = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Web\Studio\PlayStatController::index
* @see Http/Controllers/Web/Studio/PlayStatController.php:23
* @route '/studio/{team}/scenarios/{scenario}/play-stats'
*/
indexForm.head = (args: { team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } } | [team: string | number | { slug: string | number }, scenario: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

const playStats = {
    index: Object.assign(index, index),
}

export default playStats